var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "content-class": "dialog--alert",
        "max-width": "360"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [_c("v-icon", [_vm._v("warning")]), _vm._v(" Confirmar")],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", {
            staticClass: "pt-0",
            domProps: { innerHTML: _vm._s(_vm.text) }
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { id: "md-btn-confirm-selected-cancel" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.cancel()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.textCancel))]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", id: "md-btn-confirm-selected-ok" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.ok()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.textOk))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f60918b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f60918b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/plugins/modal/AppConfirm.vue
// module id = null
// module chunks = 